import { render } from "./FipeIcon.vue?vue&type=template&id=14a7250b&scoped=true"
import script from "./FipeIcon.vue?vue&type=script&lang=js"
export * from "./FipeIcon.vue?vue&type=script&lang=js"

import "./FipeIcon.vue?vue&type=style&index=0&id=14a7250b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a7250b"]])

export default __exports__